"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _inherits2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper.js"));
var _react = _interopRequireWildcard(require("react"));
var _UnexpectedError = require("../unexpected-error/UnexpectedError");
var _noop = require("../../utils/noop");
var _UISettingsError = require("../ui-settings-error/UISettingsError");
var _types = require("../../context/settings/v2/types");
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ErrorBoundary, _Component);
  var _super = (0, _createSuper2.default)(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    (0, _classCallCheck2.default)(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hasError: false,
      hasUISettingsError: false
    };
    return _this;
  }
  (0, _createClass2.default)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error('Uncaught error:', error, errorInfo);
      this.props.handleError(error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/_react.default.createElement(_UnexpectedError.UnexpectedError, null);
      } else if (this.state.hasUISettingsError) {
        return /*#__PURE__*/_react.default.createElement(_UISettingsError.SettingsError, null);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      if (error instanceof _types.UISettingsError) {
        return {
          hasUISettingsError: true,
          hasError: false
        };
      }
      return {
        hasUISettingsError: false,
        hasError: true
      };
    }
  }]);
  return ErrorBoundary;
}(_react.Component);
exports.ErrorBoundary = ErrorBoundary;
ErrorBoundary.defaultProps = {
  handleError: _noop.noop
};